import { render, staticRenderFns } from "./MedicacaoBoletimSanitario.vue?vue&type=template&id=335d01b5&scoped=true&"
import script from "./MedicacaoBoletimSanitario.vue?vue&type=script&lang=js&"
export * from "./MedicacaoBoletimSanitario.vue?vue&type=script&lang=js&"
import style0 from "./MedicacaoBoletimSanitario.vue?vue&type=style&index=0&id=335d01b5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335d01b5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VDataTable,VRow,VSimpleCheckbox})
